export default "__VITE_ASSET__d3f38d92__"